<template>
  <Modal class="mask" class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">{{title}}</div>
    <div>
      {{`是否确认${action}？`}} <br>
      {{actionother}}
    </div>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="confirm">
        <span>确定</span>
      </Button>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    action:{
      type:String,
      default:'取消'
    },
    title:{
      type:String,
      default:'消息提醒'
    },
    actionother:{
      type:String,
      default:''
    }
  },
  data () {
  return {
    show:false
 };
 },
 watch:{
   n(val){
     this.show = true;
   }
 },
 methods:{
   handleCancel(){
      this.show = false
    },
   confirm(){
     this.show = false
     this.$emit('cancel')
    }
 }
}
</script>


